import {
	Component,
	OnInit,
	ComponentFactoryResolver,
	OnDestroy,
	ViewChild,
	ElementRef,
	ViewChildren,
	QueryList,
	Renderer2, AfterViewInit
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// core
import { BroadcastService, BroadcastEventModel, SubContentService } from '@cv-invision/core';
import { PHOTO_REVIEW_UISTATE } from './model/photo-review.constant';
import { DOCUMENT_RULES_UI_SECTIONS, SCHEMA_TYPE } from '../model/quality.constant';
// service
import { PhotoReviewService } from './service/photo-review.service';
import { PhotoUtilsService } from './service/photo-review-utils.service';
import { PhotoReviewNavigationService } from './service/photo-review.navigation.service';
import { NavigationElementSelected, NavigationElementService } from '@cv-invision/cv.component-library.ux';
// app components
import { RulesComponent } from '../rules/rules.component';
// State
import { PhotoReviewState } from './state/photo-review.state';
// Models
import { RuleModel } from '../rules/model/rule.model';
import { QualityState } from '../state/quality.state';
import { OrderDetailModel } from '../state/model/order-detail.model';

import { CREATED_RULE_EVENT } from './photo-card/photo-card.component';
import { RuleEngine } from '../rules/model/rule-engine';
import { DeleteSelectedRule } from '../rules/state/action/rules.actions';
import { RulesState } from '../rules/state/rules.state';

@Component({
	selector: 'cv-photo-review',
	templateUrl: './photo-review.component.html',
	styleUrls: ['./photo-review.component.scss']
})
export class PhotoReviewComponent implements OnInit, AfterViewInit, OnDestroy {
	orderDetail$: Observable<OrderDetailModel> = this.store.select(QualityState.getOrderDetail);
	selectedRule$: Observable<any> = this.store.select(RulesState.getSelectedRule);
	@ViewChild('photocontainer', { static: false }) ele: ElementRef;
	@ViewChildren('strucuturesBtn') strBtn: QueryList<ElementRef>;
	private atComponentDestroy = new Subject();
	private orderDetailModel: OrderDetailModel;
	photos: Array<any>;
	orderWithPhotos: FormGroup = null;
	photosExterior: Array<any>;
	photosInterior: Array<any>;
	photosSketch: Array<any>;
	photosPropertyCard: Array<any>;
	photoPath: any;
	exteriorInfo: any;
	interiorInfo: any;
	sketchInfo: any;
	propertyInfoCard: any;
	selectedSketchinfo: any;
	photoReviewUiState: any;
	contentInfo: any;
	contentType: string;
	selectedTab: string;
	activeTab: string;
	filterStructure: string;
	structureOptions: Array<any>;
	selectedStructure: number;
	selectedRuleMessage: string;
	targets: any;
	uiState: string;
	sortOptions: Array<any>;
	sortvalue: string;
	sortingCard: Array<any>;
	detailContentVisble: boolean;
	schemaType: any;
	selectedSchema: string;
	resetDrop: boolean;
	isSorted: boolean;
	hasStructures: boolean;
	removedSelection: boolean;
	constructor(
		private broadcastService: BroadcastService,
		private subContentService: SubContentService,
		private photoUtils: PhotoUtilsService,
		private photoServie: PhotoReviewService,
		private renderer: Renderer2,
		public photoReviewNavigationService: PhotoReviewNavigationService,
		private navigationElementService: NavigationElementService,
		private componentFactoryResolver: ComponentFactoryResolver,
		private store: Store
	) {
		this.photoReviewUiState = PHOTO_REVIEW_UISTATE;
		this.detailContentVisble = false;
		this.schemaType = SCHEMA_TYPE;
		this.hasStructures = false;
		this.activeTab = 'ALL';
		this.targets = {
			data: [],
			primary: []
		};
	}

	ngOnInit(): void {

		RuleEngine.setSelectedSection(this.store, DOCUMENT_RULES_UI_SECTIONS.PHOTOREVIEW);

		this.uiState = this.photoReviewUiState.IS_LOADING;
		this.orderDetail$
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((orderDetailModel: OrderDetailModel) => {
				this.orderDetailModel = orderDetailModel;
				this.selectedSchema = this.orderDetailModel.schema;
			});
		// TODO: this should be changed after the firts release
		// this to avoid crash the app due to the overview and 1004 changes
		this.photoServie.getOrderDocumentData(this.orderDetailModel.id).subscribe(doc => {
			this.setTabsPhotoContent(doc);
		});
		this.getSelectedOrderPhotos();
		this.onCreatedRuleListener();
	}

	ngAfterViewInit(): void {
		// After a rule has been selected if it belongs to the same section it will try to Highlight the Field
		this.selectedRule$.pipe(takeUntil(this.atComponentDestroy)).subscribe((selectedRule: any) => {
			if (selectedRule && RuleEngine.isCurrentUISection(selectedRule, DOCUMENT_RULES_UI_SECTIONS.PHOTOREVIEW)) {
				setTimeout(() => {
					this.getSelectedRule(selectedRule);
					// We Clean latest value
					this.store.dispatch(new DeleteSelectedRule());
				});
			}
		});
	}

	/**
	 * clear the result for the currentent rule selection
	 */
	clearRuleSelection(): void {
		this.selectedRuleMessage = null;
		this.removedSelection = this.targets.data.length ? true : false;
		this.sortingCard = [];
		this.isSorted = !!this.sortingCard.length;
	}

	/**
	 * Load the PhotoReview  Rules through store managment and then open the Rules SubContent panel.
	 *
	 */
	private loadPhotoReviewRules(): void {
		this.subContentService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: RulesComponent,
				data: {
					uiSection: DOCUMENT_RULES_UI_SECTIONS.PHOTOREVIEW,
					targets: this.targets
				}
			})
			.subscribe(updateEvent => {
				this.getSelectedRule(updateEvent);
			});
	}

	/**
	 * get the rule selected
	 * @param item selected rule model
	 */
	getSelectedRule(item: RuleModel): void {
		const filterType = item.targets.length ? item.targets : item.primaryTargets;
		const matchRule = this.photos.filter(p => filterType.includes(p.photoRefJsonPath));
		this.sortingCard = matchRule;
		this.isSorted = !!this.sortingCard.length;
		this.hasStructures = false;
		this.resetDrop = true;
		this.selectedRuleMessage = null;
		this.navigationElementService.changeNavigationElements([]);
		if (matchRule.length) {
			this.removedSelection = this.targets.data.length ? true : false;
			this.detailContentVisble = false;
			this.activeTab = this.photoReviewUiState.TAB_TITLES.ALL;
			this.selectedRuleMessage = item.messageType;
			this.ele.nativeElement.scrollTop = 0;
		}
	}

	/**
	 * get info from a selected photo card
	 */
	getPhotoInfo(item: any): void {
		if (this.activeTab === this.photoReviewUiState.TAB_TITLES.INTERIOR) {
			this.contentInfo = item;
			return;
		}
		if (this.activeTab === this.photoReviewUiState.TAB_TITLES.ALL) {
			this.setTargetsData(item);
		}
	}

	/**
	 * set the info tasrts
	 */
	setTargetsData(item: any): void {
		if (item && this.targets) {
			const { removed, path } = item;
			if (removed) {
				this.targets.data = this.targets.data.filter(t => t !== path);
				this.targets.primary = this.targets.primary.filter(t => t !== path);
				return;
			}
			this.targets.data.push(path);
			this.targets.primary.push(path);
		}
	}

	/**
	 * Listener for when a rule is created
	 */
	private onCreatedRuleListener(): void {
		this.broadcastService.on(CREATED_RULE_EVENT, (broadcast: BroadcastEventModel) => {
			this.targets = {
				data: [],
				primary: []
			};
		});
	}

	/**
	 * to execute when an element from the navigation was selected
	 * @param event navigationElementSelected
	 */
	navigationElementSelected(event: NavigationElementSelected): void {
		this.clearRuleSelection();
		const photos = this.photoReviewNavigationService.getPhotos(event.control.getRawValue());
		if (photos && photos.length > 0) {
			const filteredPhotos = this.photoUtils.mapAllPhoto(photos)[0];
			if (this.photos.length !== filteredPhotos.length) {
				this.sortingCard = this.photoUtils.mapAllPhoto(photos)[0];
				this.isSorted = true;
				this.ele.nativeElement.scrollTop = 0;
			}
		}
	}
	/**
	 * get current selected photos order
	 */
	getSelectedOrderPhotos(): void {
		this.store
			.select(PhotoReviewState.getPhotoReviewCollection)
			.subscribe((currentPhotos: Array<any>) => {
				if (!currentPhotos || !currentPhotos.length) {
					this.uiState = this.photoReviewUiState.NO_PHOTOS;
				}
				this.photoDataMaping(currentPhotos);
			});
	}

	/**
	 * map the result from the api to a new object
	 * @param data photo data
	 */
	photoDataMaping(data: Array<any>): void {
		if (!data || !data.length) {
			this.uiState = this.photoReviewUiState.NO_PHOTOS;
			return;
		}
		if (this.selectedSchema === this.schemaType.INSPECTION_R) {
			this.orderWithPhotos = this.photoReviewNavigationService.getOrder(data);
			this.photoPath = data;
			const mappedPhoto = this.photoUtils.mapAllPhoto(data);
			this.photosSketch = this.photoUtils.getGeneralPhotos(
				data,
				PHOTO_REVIEW_UISTATE.TAB_TITLES.SKETCH
			);
			this.photosPropertyCard = this.photoUtils.getGeneralPhotos(
				data,
				PHOTO_REVIEW_UISTATE.TAB_TITLES.PROPERTY_CARD
			);
			this.photos = mappedPhoto[0];
			this.sortOptions = mappedPhoto[1];
			this.uiState = this.photoReviewUiState.HAS_PHOTOS;
		}

		if (this.selectedSchema !== this.schemaType.INSPECTION_R) {
			this.photos = data;
			this.uiState = this.photoReviewUiState.HAS_PHOTOS;
		}
	}

	/**
	 * set all the information reletated with each tab in the component
	 * @param doc document order
	 */
	setTabsPhotoContent(doc: any): void {
		if (
			this.uiState !== this.photoReviewUiState.NO_PHOTOS &&
			doc.InspectionReport &&
			this.selectedSchema === this.schemaType.INSPECTION_R
		) {
			const { property } = doc.InspectionReport;
			const exterior = property.structures;
			if (!exterior[0].cv_photos) {
				this.uiState = this.photoReviewUiState.NO_PHOTOS;
				return;
			}
			this.propertyInfoCard = property.cv_photos.filter(
				cvp => cvp.photoType === this.photoReviewUiState.PROPERTY_CARD
			);
			this.interiorInfo = this.photoUtils.mapInteriorInfo(exterior, this.photoPath);

			this.exteriorInfo = this.photoUtils.mapExteriorInfo(exterior, this.photoPath);

			this.sketchInfo = this.photoUtils.mapSketchInfo(exterior);
			this.structureOptions = this.exteriorInfo.map(e => e.structureType);
			this.filterStructure = this.structureOptions[0];
			this.setPhotosDocumentData(this.filterStructure);
		}
	}

	/**
	 * set information depend on data structure
	 * @param criteria structure type
	 */
	setPhotosDocumentData(criteria: string): void {
		this.photosExterior = this.exteriorInfo
			.filter(e => e.structureType === criteria)
			.map(p => p.photos)
			.pop();
		this.photosInterior = this.interiorInfo
			.filter(i => i.structureType === criteria)
			.map(p => p.photos)
			.flat()
			.pop();

		this.selectedSketchinfo = this.sketchInfo.filter(s => s.structureType === criteria).pop();
	}

	/**
	 * set aditional information depend on data and tab info
	 * @param tab tasb selectd
	 * @param criteria structure type
	 */
	setContentInfoData(tab: string, criteria: string): void {
		this.contentType = tab;
		if (tab === this.photoReviewUiState.TAB_TITLES.EXTERIOR) {
			this.contentInfo = (({
				exteriorDeficiencies,
				exteriorFeatures,
				exteriorUpdates,
				mechanicalDeficiencies
			}) => ({
				exteriorDeficiencies,
				exteriorFeatures,
				exteriorUpdates,
				mechanicalDeficiencies
			}))(this.exteriorInfo.filter(e => e.structureType === criteria).pop());
		}
		if (tab === this.photoReviewUiState.TAB_TITLES.SKETCH) {
			this.contentInfo = this.selectedSketchinfo;
		}
		if (tab === this.photoReviewUiState.TAB_TITLES.PROPERTY_CARD) {
			this.contentInfo = this.propertyInfoCard;
		}
		if (tab === this.photoReviewUiState.TAB_TITLES.INTERIOR) {
			this.contentInfo = null;
		}
	}

	/**
	 * set active or inactive structure btn
	 * @param pos
	 */
	setStructuresBtnStyles(pos: number): void {
		this.strBtn.forEach((el, i) => {
			if (i === pos) {
				this.renderer.removeClass(el.nativeElement, PHOTO_REVIEW_UISTATE.CARD.INACTIVE_BTN_SRT);
				this.renderer.addClass(el.nativeElement, PHOTO_REVIEW_UISTATE.CARD.SELECTED_BTN_SRT);
			} else {
				this.renderer.removeClass(el.nativeElement, PHOTO_REVIEW_UISTATE.CARD.SELECTED_BTN_SRT);
				this.renderer.addClass(el.nativeElement, PHOTO_REVIEW_UISTATE.CARD.INACTIVE_BTN_SRT);
			}
		});
	}

	/**
	 * set photos and extra info for document photos
	 * @param opt selected structure type
	 */
	structurePhotos(opt: any, pos: number): void {
		this.setStructuresBtnStyles(pos);
		this.selectedStructure = pos;
		this.filterStructure = opt || this.structureOptions[0];
		this.setPhotosDocumentData(this.filterStructure);
		this.setContentInfoData(this.activeTab, this.filterStructure);
	}

	/**
	 * get active tab
	 * @param sortBy get active tab
	 */
	getActiveTab(tab: any): void {
		this.detailContentVisble = tab.title !== this.photoReviewUiState.TAB_TITLES.ALL ? true : false;
		this.activeTab = tab.title;
		if (this.detailContentVisble) {
			this.hasStructures = this.structureOptions && this.structureOptions.length > 1 ? true : false;
			this.targets = { data: [], primary: [] };
			this.removedSelection = true;
			this.setContentInfoData(this.activeTab, this.filterStructure);
			setTimeout(() => {
				this.setStructuresBtnStyles(this.selectedStructure || 0);
			}, 50);
		} else {
			this.hasStructures = false;
			this.removedSelection = false;
		}
	}

	/**
	 * Close all when the element is destroyed
	 * in case a Sub Component remains visible
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
